const SuperiorCountriesActionType = {
  GET_SUPERIOR_COUNTRIES: 'GET_SUPERIOR_COUNTRIES',
  SAVE_SUPERIOR_COUNTRIES: 'SAVE_SUPERIOR_COUNTRIES',
  RESET_SUPERIOR_COUNTRIES: 'RESET_SUPERIOR_COUNTRIES',
  EDIT_SUPERIOR_COUNTRIES: 'EDIT_SUPERIOR_COUNTRIES',
  DELETE_SUPERIOR_COUNTRIES: 'DELETE_SUPERIOR_COUNTRIES',
};

export default SuperiorCountriesActionType;
